import React from "react";
import { Space, Typography, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const SubscriptionDrawerMetaRow = ({ label, children, tooltip } : {
    label: string;
    children: React.ReactNode;
    tooltip?: string;
}) => {


    return (<div>
        <Space>
            <Text type="secondary">{label}</Text>
            {tooltip ? (
                <Tooltip title={tooltip}>
                    <InfoCircleOutlined />
                </Tooltip>
            ) : null}
        </Space>
        <div>{children}</div>
    </div>)

}


export default SubscriptionDrawerMetaRow;